import { ZIndexLayer as SdkZIndexLayer } from "@product/scmp-sdk";

export enum ZIndexLayer {
  AppBar = 1300,
  AppTooltip = 1100,
  ArticleAuthorFollowButton = 1001,
  Drawer = 1400,
  DropdownSelect = 1350,
  EditionInvitation = 1900,
  GoogleOneTapSignIn = 2000,
  HamburgerMenu = 1800,
  LiveUpdateAlert = 4000,
  Modal = SdkZIndexLayer.Modal,
  NewsletterArticleFloatingWidget = 1000,
  NewsletterArticleIssues = 1200,
  OnboardingDialog = 3000,
  PlusDatePicker = 1202,
  PlusListingPopup = 2200,
  PlusPopup = 2100,
  SnackBar = 1600,
  StoryCardCarouselWidget = 1102,
  TakeoverAd = 1101,
  Tooltip = SdkZIndexLayer.Tooltip,
}
